import { InjectionToken } from '@angular/core';

export const SITE_ORIGIN: InjectionToken<string> = new InjectionToken<string>('SITE_ORIGIN');
